import React, { useState } from 'react'

import { Box, Text, useBreakpoint } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { CheckCircle, Files } from '@factorialco/f0-react/icons/app'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import ChooseRewardModal from 'modules/referral_program/components/ChooseRewardModal'

interface HeaderLinkProps {
  shareUrl: string
  isoCountryCode: string
}

const HeaderLink: React.FC<HeaderLinkProps> = ({ shareUrl, isoCountryCode }) => {
  const { isMobile } = useBreakpoint()
  const [copied, setCopied] = useState(false)
  const [openLinkModal, setOpenLinkModal] = useState(false)
  const [rewardSelected, setRewardSelected] = useState<string | null>('price_4')
  const [linkGenerated, setLinkGenerated] = useState(true)
  const isBrazil = isoCountryCode === 'br'

  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareUrl)
    setCopied(true)
    app.setFlash({
      type: 'correct',
      message: i18n.t('common.copied'),
    })
    track(trackingEvents.settings.copyReferralProgramLink)

    setTimeout(() => setCopied(false), 2000)
  }

  // const handleReset = () => {
  //   track(trackingEvents.settings.clickResetReferralProgramLink)
  //   setRewardSelected(null)
  //   setLinkGenerated(false)
  //   setOpenLinkModal(true)
  // }

  // const handleGenerateLink = () => {
  //   track(trackingEvents.settings.clickGenerateReferralProgramLink)
  //   setOpenLinkModal(true)
  // }

  return (
    <>
      <Box
        style={{
          flex: '2',
        }}
        gap="s16"
        alignItems="flexStart"
        justifyContent="center"
        width={isMobile ? 'full' : undefined}
        minWidth="s200"
        maxWidth={isMobile ? 'full' : 's400'}
      >
        <Text weight="bold" size="500" color="black">
          {i18n.t('company_settings.general.factorial_referral_program.iphone_air.title_landing')}
        </Text>

        <Box maxWidth="full">
          <Text size="300" className="text-f1-foreground-secondary">
            {isBrazil
              ? i18n.t(
                  'company_settings.general.factorial_referral_program.landing.subtitle_landing_brazil',
                  {
                    amount: '200$',
                    max_discount: '3000$',
                  }
                )
              : i18n.t(
                  'company_settings.general.factorial_referral_program.iphone_air.subtitle_landing'
                )}
          </Text>
        </Box>
        {rewardSelected && linkGenerated && (
          <Box gap="s12" width="full">
            <>
              <input
                type="text"
                value={shareUrl}
                readOnly
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #D1D5DB',
                  borderRadius: '12px',
                  fontSize: '14px',
                  backgroundColor: 'rgba(5, 31, 81, 0.04)',
                  height: '40px',
                  textOverflow: 'ellipsis',
                }}
              />
            </>
            <Box
              flexDirection={isMobile ? 'column' : 'row'}
              gap="s8"
              width="full"
              borderRadius={{ all: 'abs012' }}
            >
              <F0Button
                size="lg"
                onClick={handleCopyLink}
                label={
                  copied
                    ? i18n.t(
                        'company_settings.general.factorial_referral_program.revamp.button.share_link'
                      )
                    : i18n.t(
                        'company_settings.general.factorial_referral_program.revamp.button.copy_link'
                      )
                }
                icon={copied ? CheckCircle : Files}
              />
              {/* <F0Button
                size="lg"
                onClick={handleReset}
                label={i18n.t(
                  'company_settings.general.factorial_referral_program.revamp.button.reset'
                )}
                variant="ghost"
                icon={Reset}
              /> */}
            </Box>
          </Box>
        )}
        {/* {!linkGenerated && (
          <Box
            flexDirection={isMobile ? 'column' : 'row'}
            gap="s8"
            width="full"
            borderRadius={{ all: 'abs012' }}
          >
            <F0Button
              size="lg"
              onClick={handleGenerateLink}
              label={i18n.t(
                'company_settings.general.factorial_referral_program.revamp.button.generate_link'
              )}
            />
          </Box>
        )} */}
      </Box>
      <ChooseRewardModal
        open={openLinkModal}
        onClose={() => setOpenLinkModal(false)}
        rewardSelected={rewardSelected}
        setRewardSelected={setRewardSelected}
        setLinkGenerated={setLinkGenerated}
      />
    </>
  )
}

export default HeaderLink
